import type { UpdateApproachabilityInput } from '@seek/ca-graphql-schema/types';

import type {
  UpdateProfileVisibility2Input,
  UpdateProfileVisibilityInput,
} from 'src/types/graphql';

import {
  mockProfileVisibilityOptions,
  profileVisibility2,
} from './profileVisibility-mock';
import { getOptionFromProfileVisibilityId } from './utils';

const UpdateProfileVisibility2Payload = {
  __resolveType: (arg0: any) => arg0.__typename,
};

const ProfileVisibilityOption = {
  __resolveType: (arg0: any) => arg0.__typename,
};

const Query = {
  profileVisibilityOptions: () => mockProfileVisibilityOptions,
};

const Candidate = {
  profileVisibility2: () => profileVisibility2,
};

const Mutation = {
  updateProfileVisibility2: (
    _: unknown,
    { input }: { input: UpdateProfileVisibility2Input },
  ) => {
    // Mocked to show error toast for "Limited" option:
    if (input.id === 'Limited') {
      return {
        __typename: 'UpdateProfileVisibility2Failure',
        error: {
          message: 'Error Message',
        },
      };
    }
    const option = getOptionFromProfileVisibilityId(
      mockProfileVisibilityOptions,
      input.id,
    );

    return {
      __typename: 'UpdateProfileVisibility2Success',
      viewer: {
        _id: '34712547',
        id: 34712547,
        profileVisibility2: {
          ...option,
        },
      },
    };
  },

  updateProfileVisibility: (
    _: unknown,
    { input }: { input: UpdateProfileVisibilityInput },
  ) => {
    if (input.level === 'Limited') {
      return new Error(); // Mocked to show error toast for "Limited" option
    }

    const legacyVisibilityLevelToNewOption = {
      Standard: {
        __typename: 'StandardVisibilityOption',
        id: 'Standard',
        label: 'Standard',
        description: 'Standard',
      },
      Limited: {
        __typename: 'LimitedVisibilityOption',
        id: 'Limited',
        label: 'Limited',
        description: 'Limited',
      },
      Hidden: {
        __typename: 'HiddenVisibilityOption',
        id: 'Hidden',
        label: 'Hidden',
        description: 'Hidden',
      },
    };
    const option = legacyVisibilityLevelToNewOption[input.level];

    return {
      viewer: {
        _id: '34712547',
        id: 34712547,
        profileVisibility: {
          level: input.level,
          description: input.level,
        },

        profileVisibility2: {
          ...option,
        },
      },
    };
  },

  updateApproachability: (
    _: unknown,
    { input }: { input: UpdateApproachabilityInput },
  ) => ({
    viewer: {
      _id: '34712547',
      id: 34712547,
      approachability: input,
    },
  }),
};

export {
  UpdateProfileVisibility2Payload,
  ProfileVisibilityOption,
  Query,
  Candidate,
  Mutation,
};
